import * as Rx from 'rxjs';
import { tap } from 'rxjs/operators';
import apiService from 'v2/services/api';

import type { ApiService } from 'v2/services/api';

export type NewRefundServicePermission = {
  success: boolean;
  data: { producer_can_access: boolean; customer_can_access: boolean };
};

export class NewRefundService {
  private loading$ = new Rx.BehaviorSubject<boolean>(false);
  constructor(private apiService: ApiService) {}

  public getPermissionToNewRefundServiceByInvoiceId(invoiceId: string) {
    this.loading$.next(true);
    return this.apiService.get(`invoices/${invoiceId}/new-refund-service`).pipe(tap(() => this.loading$.next(false)));
  }
}

const newRefundService = new NewRefundService(apiService);
export default newRefundService;
